import gql from 'graphql-tag';

export const GET_JOBS = gql`
query{
  me{
    id
    name
    ApplicationsGet(first: 3){
      data{
        is_Done
        job{
          id
          title
         	brif
          created_at
          company{name logo{url}}
          questions{
            title
          }
          applications_count
          tags{name}
        }
      }
    }
  }
}`